import { WifiOff, RefreshCw, Send } from "lucide-react";

interface OfflineBannerProps {
  isOnline: boolean;
  outboxCount: number;
  isSyncing: boolean;
  onSyncNow?: () => void;
}

export default function OfflineBanner({
  isOnline,
  outboxCount,
  isSyncing,
  onSyncNow,
}: OfflineBannerProps) {
  if (isOnline && outboxCount === 0 && !isSyncing) {
    return null;
  }

  return (
    <div
      className={`px-3.5 pt-[max(0.375rem,env(safe-area-inset-top))] pb-1.5 text-2xs flex items-center justify-between transition-colors ${
        !isOnline
          ? "bg-amber-500/15 border-b border-amber-500/30 text-amber-600 dark:text-amber-400"
          : isSyncing
          ? "bg-accent/15 border-b border-accent/30 text-accent"
          : "bg-blue-500/15 border-b border-blue-500/30 text-blue-600 dark:text-blue-400"
      }`}
    >
      <div className="flex items-center gap-2">
        {!isOnline ? (
          <WifiOff size={13} className="flex-shrink-0 animate-pulse" />
        ) : isSyncing ? (
          <RefreshCw size={13} className="flex-shrink-0 animate-spin" />
        ) : (
          <Send size={13} className="flex-shrink-0" />
        )}

        <span className="font-medium">
          {!isOnline
            ? "Sin conexión — Modo offline activo (consultando correos guardados)"
            : isSyncing
            ? "Conexión restaurada — Sincronizando cola de salida..."
            : `Conectado — ${outboxCount} correo(s) en cola de salida`}
        </span>
      </div>

      <div className="flex items-center gap-2">
        {outboxCount > 0 && (
          <span className="font-semibold px-1.5 py-0.5 bg-black/10 dark:bg-white/10 text-2xs">
            {outboxCount} en espera
          </span>
        )}

        {isOnline && outboxCount > 0 && !isSyncing && onSyncNow && (
          <button
            onClick={onSyncNow}
            className="px-2 py-0.5 font-semibold bg-accent text-white hover:bg-accent-hover transition-colors"
          >
            Sincronizar ahora
          </button>
        )}
      </div>
    </div>
  );
}
